import { Drawer } from '@mui/material';
import { FC } from 'react';
import { SidebarContent } from './SidebarContent';

interface Props {
  open: boolean;
  onClose: () => void;
}

export const SidebarDrawer: FC<Props> = ({ open, onClose }) => {
  return (
    <Drawer
      anchor="left"
      onClose={onClose}
      open={open}
      PaperProps={{
        sx: {
          backgroundColor: 'background.paper',
          width: 280,
        },
      }}
      variant="temporary"
    >
      <SidebarContent collapsed={false} />
    </Drawer>
  );
};
